export default __webpack_public_path__ + "static/media/icon_advantage.896a7186.webp";